import React from "react";

const NotFoundPage: React.FC = () => {

    return (
        <div className="notfindpage w-100 h100vh align-content-center justify-content-center d-flex">
           <div className="w-100 h-100"></div>
        </div>
    );
};

export default NotFoundPage;
